// Works out the order mammoth applies rules in (first match wins) and which rules overlap.
const STYLED = ["p", "r", "table"];

export function tierOf(rule) {
  if (rule.priority === "first") return 0;
  if (rule.priority === "last") return 5;
  if (rule.raw !== undefined) return 3;
  if (rule.group === "quiet") return 4;
  if (STYLED.includes(rule.match) && rule.style) return rule.prefix ? 2 : 1;
  return 3;
}

export function orderedIndexes(rules) {
  return rules
    .map((rule, index) => ({ index, tier: tierOf(rule) }))
    .sort((a, b) => a.tier - b.tier || a.index - b.index)
    .map(({ index }) => index);
}

export function orderRules(rules) {
  return orderedIndexes(rules).map((index) => rules[index]);
}

export function rulesOverlap(a, b) {
  if (a.raw !== undefined || b.raw !== undefined || a.match !== b.match) return false;
  const aStyled = Boolean(a.style);
  const bStyled = Boolean(b.style);
  if (aStyled !== bStyled) return true; // a catch-all against a named rule
  if (!aStyled) return true; // two catch-alls for the same thing
  const aName = a.style.toLowerCase();
  const bName = b.style.toLowerCase();
  if (aName === bName) return true;
  return Boolean((a.prefix && bName.startsWith(aName)) || (b.prefix && aName.startsWith(bName)));
}

export function findOverlaps(rules) {
  const position = new Map(orderedIndexes(rules).map((ruleIndex, place) => [ruleIndex, place]));
  const overlaps = new Map();
  for (let i = 0; i < rules.length; i++) {
    for (let j = i + 1; j < rules.length; j++) {
      if (!rulesOverlap(rules[i], rules[j])) continue;
      for (const [self, other] of [[i, j], [j, i]]) {
        const entry = overlaps.get(self) ?? { with: [], wins: true };
        entry.with.push(other);
        if (position.get(self) > position.get(other)) entry.wins = false;
        overlaps.set(self, entry);
      }
    }
  }
  return overlaps;
}
